'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newKey = function newKey() {
  return Date.now();
};

var FileInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FileInput, _Component);

  function FileInput() {
    var _ref;

    (0, _classCallCheck3.default)(this, FileInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = FileInput.__proto__ || (0, _getPrototypeOf2.default)(FileInput)).call.apply(_ref, [this].concat(args)));

    _this._onFilesSelected = function (e) {
      _this.props.uploader.methods.addFiles(e.target);
      _this._resetInput();
    };

    _this.state = { key: newKey() };
    return _this;
  }

  (0, _createClass3.default)(FileInput, [{
    key: '_resetInput',
    value: function _resetInput() {
      this.setState({ key: newKey() });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          uploader = _props.uploader,
          className = _props.className,
          elementProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'uploader', 'className']); // eslint-disable-line no-unused-vars

      return _react2.default.createElement(
        'label',
        { className: (0, _classnames2.default)('fileInputContainer', className), key: this.state.key },
        children,
        _react2.default.createElement('input', (0, _extends3.default)({ type: 'file' }, elementProps, { className: 'fileInput', onChange: this._onFilesSelected }))
      );
    }
  }]);
  return FileInput;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  uploader: _propTypes2.default.object.isRequired
}, _temp);
exports.default = FileInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/FileInput.js
// module id = 1994
// module chunks = 1